import { create } from "zustand";

import { ReportInterface, reportSlice } from "./report";

export const useReportStore = create<ReportInterface>()((...a) => ({
  ...reportSlice(...a),
}));
